import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import urls from "../../urls";

const NavMenu = () => {
  const { t } = useTranslation();
  return (
    <div className={"main-menu"}>
      <nav>
        <ul>
          <li>
            <NavLink to={urls.home} activeClassName="active" exact>
              {t("home")}
            </NavLink>
          </li>
          <li>
            <NavLink to={urls.shop} activeClassName="active" exact>
              {t("collection")}
            </NavLink>
          </li>
          {/*<li>*/}
          {/*  <NavLink to={urls.recipes} activeClassName="active" exact>*/}
          {/*    {t("recipes")}*/}
          {/*  </NavLink>*/}
          {/*</li>*/}
          <li>
            <NavLink to={urls.about} activeClassName="active">{t("about_us")}</NavLink>
          </li>
          <li>
            <NavLink to={urls.delivery_returns} activeClassName="active">{t("shipping")}</NavLink>
          </li>
          <li>
            <NavLink to={urls.contact} activeClassName="active">{t("contact")}</NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default NavMenu;
